export default (state: any) => {
  const { reasonDetails: { error = null, isLoading = null, ...reasonDetails } = {} } = state.reasons || {};

  return {
    ...state,
    reasonDetails,
  };
};
